<template>
  <div class="xzxx-detail">
    <div class="detail-box ques-info">
      <p class="title" ref="titleBox">
        {{ detailInfo.TITLE }}
      </p>
      <div class="content">
        <img
          class="statusImg"
          v-if="detailInfo.IS_REPLY == '1'"
          src="../../../static/assets/reply.png"
        />
        <img
          class="statusImg"
          v-if="detailInfo.IS_REPLY == '0'"
          src="../../../static/assets/unreply.png"
        />
        <p class="sub-title">
          <img src="../../../static/assets/ask.png" />
          <span>{{ detailInfo.MAIL_TYPE_DISPLAY }}</span>
          <span v-if="detailInfo.CREATE_TIME">{{ detailInfo.CREATE_TIME }}</span>
        </p>
        <div class="detail-text" v-html="detailInfo.CONTENT"></div>
        <attachment-cell
          v-for="(att, index) in detailInfo.LETTER_FJ"
          :option="att"
          :key="index"
        ></attachment-cell>
      </div>
    </div>
    <div class="detail-box answ-info" v-if="detailInfo.IS_REPLY == '1'">
      <p class="sub-title">
        <img src="../../../static/assets/answer.png" />
        <span>回复</span>
        <span v-if="detailInfo.REPLY_TIME">{{ detailInfo.REPLY_TIME }}</span>
      </p>
      <div class="detail-text" v-html="detailInfo.REPLY_CONTENT"></div>
      <attachment-cell
        v-for="(att, index) in detailInfo.REPLY_FJ"
        :option="att"
        :key="index"
      ></attachment-cell>
    </div>
  </div>
</template>
<script>
import * as utils from "../../utils";
import api from "../../api";
import { Toast } from "bh-mint-ui2";
import attachmentCell from "./attachmentCell";
export default {
  name: "mobileDetail",
  components: {
    attachmentCell,
  },
  data() {
    return {
      detailInfo: {},
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      utils
        .Post(api.getDetail, {
          WID: this.$route.query.WID,
        })
        .then((res) => {
          if (
            res.code == "0" &&
            res.datas &&
            res.datas.T_OA_DXZXX_QUERY &&
            res.datas.T_OA_DXZXX_QUERY.rows
          ) {
            this.detailInfo = res.datas.T_OA_DXZXX_QUERY.rows[0] || {};
            utils
              .Post(api.getUploadedAttachment, {
                fileToken: this.detailInfo.ATT_TOKEN || "",
              })
              .then((resp) => {
                this.$set(this.detailInfo, "LETTER_FJ", resp.items);
              });
          } else {
            Toast(res.message || "获取详情出错!");
          }
        });
    },
    setTime(val) {
      console.log(val, "00");
      const date = new Date(val.replace(/-/g, "/"));
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const hour = date.getHours().toString().padStart(2, "0");
      const min = date.getMinutes().toString().padStart(2, "0");
      return year + "-" + month + "-" + day + " " + hour + ":" + min;
    },
  },
};
</script>
<style scoped>
.xzxx-detail {
  padding: 24px 12px;
  background: url(../../../static/assets/bg2.png) no-repeat;
  background-size: 100% auto;
}

.xzxx-detail .detail-box {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px 12px;
  position: relative;
  margin-bottom: 10px;
}

.xzxx-detail .detail-box.ques-info .content {
  position: relative;
}

.xzxx-detail .detail-box.ques-info .statusImg {
  position: absolute;
  top: -26px;
  right: 0;
  width: 90px;
  height: 90px;
}

.xzxx-detail .detail-box:last-of-type {
  margin-bottom: 0;
}

.xzxx-detail .detail-box.ques-info .title {
  color: #121212;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  border-bottom: 0.5px solid rgba(18, 18, 18, 0.08);
  padding-bottom: 16px;
  margin-bottom: 16px;
}

.xzxx-detail .detail-box .sub-title {
  display: flex;
  align-items: center;
}

.xzxx-detail .detail-box .sub-title img {
  width: 18px;
  height: 18px;
}

.xzxx-detail .detail-box .sub-title span {
  color: #8c8c8c;
  font-size: 13px;
  line-height: 18px;
}

.xzxx-detail .detail-box .sub-title span:first-of-type {
  color: #2e8cf0;
  margin: 0 10px 0 4px;
  font-size: 14px;
  line-height: 20px;
}

.xzxx-detail .detail-box .detail-text {
  color: #5f5f5f;
  font-size: 14px;
  line-height: 22px;
  margin: 16px 0;
  user-select: all;
}

.xzxx-detail .detail-box .detail-text * {
  user-select: all;
}

.xzxx-detail .detail-box.ques-info .mint-cell,
.xzxx-detail .detail-box.answ-info .mint-cell {
  background: #f8f8f8;
  border-radius: 8px;
  margin-bottom: 12px;
  min-height: 62px;
}

.xzxx-detail .mint-cell-wrapper {
  border: none;
}
</style>



// WEBPACK FOOTER //
// index.vue?0f6e1417